/**
 * state/num.ts — числовая гигиена состояния (M2; находка ревью M1: «-0-ловушка»).
 *
 * JSON не различает -0 и 0 (`JSON.stringify(-0) === "0"`, но `JSON.parse("-0")`
 * возвращает -0), поэтому появление -0 в состоянии или событиях ломало бы
 * байт-стабильность round-trip и golden-хэши (tech/25 §1, tech/26 §4): в памяти
 * -0, после serialize→deserialize уже 0. Вся арифметика урона/статов/правил
 * ОБЯЗАНА нормализовать результат через normalizeZero.
 */
/** Нормализовать -0 → 0; прочие значения возвращаются как есть. */
export function normalizeZero(x) {
    return x === 0 ? 0 : x;
}
/** Guard: конечное число (не NaN/±Infinity) — понятная ошибка в стиле M1. */
export function assertFiniteNumber(x, where) {
    if (typeof x !== 'number' || !Number.isFinite(x)) {
        throw new Error(`${where}: ожидалось конечное число (получено ${String(x)})`);
    }
}
/** Guard: целое число (детерминированная арифметика статов без дрейфа float). */
export function assertInteger(x, where) {
    if (!Number.isInteger(x)) {
        throw new Error(`${where}: ожидалось целое число (получено ${String(x)})`);
    }
}
//# sourceMappingURL=num.js.map